 "use strict";
 /**
  * trsHight Module
  *
  * Description
  */
 angular.module('pwdStrengthModule', []).directive('pwdStrength', ["$compile", "$timeout", function($compile, $timeout) {

     return {
         restrict: 'EA',
         scope: false,
         link: function(scope, iElement, iAttrs) {
             initStatus();
             initData();
             /**
              * [initStatus description] 初始化状态
              * @return {[type]} [description]
              */
             function initStatus() {
                 scope.status.modes = 0;
                 loadTemplate();
                 bindKeyDown();
             }
             /**
              * [bindKeyDown description] 绑定输入框的输入事件
              * @return {[type]} [description]
              */
             function bindKeyDown() {
                 iElement.bind("keyup", function() {
                     var sValue = $(this).val();
                     var modes = 0;
                     if (sValue.length < 8) {
                         $timeout(function() {
                             scope.status.modes = 0;
                         });
                         return;
                     }
                     if (/\d/.test(sValue)) modes++; //数字
                     if (/[a-z]/i.test(sValue)) modes++; //英文字母
                     if (/\W|_/.test(sValue)) modes++; //特殊字符
                     $timeout(function() {
                         scope.status.modes = modes;
                     });
                 });
             }

             function loadTemplate() {
                 scope.status.template = $('<div ng-class="{\'ruo\':status.modes==1,\'zhong\':status.modes==2,\'qiang\':status.modes>=3}" class="tip pwdstrength">' +
                     '<span ng-class="{\'selected\':status.modes>=1}" class="weak" ng-bind="status.modes==1||status.modes==0?\'弱\':\'&nbsp;\'"></span>' +
                     '<span ng-class="{\'selected\':status.modes>=2}" class="middle"  ng-bind="status.modes==2||status.modes==0?\'中\':\'&nbsp\'"></span>' +
                     '<span ng-class="{\'selected\':status.modes>=3}" class="strong"  ng-bind="status.modes>=3||status.modes==0?\'强\':\'&nbsp\'">强</span>' +
                     '</div>');
                 scope.status.template = $compile(scope.status.template)(scope);
                 scope.status.template.insertAfter(iElement);
             }
             /**
              * [initData description] 初始化数据
              * @return {[type]} [description]
              */
             function initData() {}
         }
     };
 }]);